/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcphosted_Hub_ClaudeInputs */

const en_mcphosted_hub_claude = /** @type {(inputs: Mcphosted_Hub_ClaudeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claude.ai — Settings → Connectors → Add custom connector.`)
};

const id_mcphosted_hub_claude = /** @type {(inputs: Mcphosted_Hub_ClaudeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claude.ai — Settings → Connectors → Add custom connector.`)
};

/**
* | output |
* | --- |
* | "Claude.ai — Settings → Connectors → Add custom connector." |
*
* @param {Mcphosted_Hub_ClaudeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mcphosted_hub_claude = /** @type {((inputs?: Mcphosted_Hub_ClaudeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcphosted_Hub_ClaudeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mcphosted_hub_claude(inputs)
	return en_mcphosted_hub_claude(inputs)
});